import { Component, OnInit } from '@angular/core';
import { RepositoryStatsService } from 'src/app/shared/services/repository-stats.service';

@Component({
  selector: 'ds-home-news',
  styleUrls: ['./home-news.component.scss'],
  templateUrl: './home-news.component.html'
})

/**
 * Component to render the news section on the home page
 */
export class HomeNewsComponent implements OnInit {

  researchPapers = 0;
  theses = 0;
  journals = 0;
  communities = 0;

  constructor(private statsService: RepositoryStatsService) {}

  ngOnInit(): void {
    this.statsService.getStats().subscribe(res => {
      this.researchPapers = res.researchPapers;
      this.theses = res.theses;
      this.journals = res.journals;
      this.communities = res.communities;
    });
  }
}
